import { Pipe, PipeTransform } from '@angular/core';
import { Renderable } from 'src/openapi-client/model/renderable';

@Pipe({
  name: 'transformChartOptions',
  standalone: true,
})

export class TransformChartOptionsPipe implements PipeTransform {
  public transform(options: Highcharts.Options | Renderable, ...transformers: Array<null | undefined | ((options: Highcharts.Options) => Highcharts.Options)>): Highcharts.Options {
    let modified: Highcharts.Options = options as Highcharts.Options;
    for (const transformer of transformers) {
      if (typeof transformer !== 'function') {
        continue;
      }

      modified = transformer(modified);
    }
    return modified;
  }
}
